"use client";
import { useState } from "react";
import Image from "next/image";
import { whyChooseUsData } from "@/utils/constants";

const WhyChooseUs = () => {
  const [openIndex, setOpenIndex] = useState<number>();

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? -1 : i);
  };

  return (
    <section className="min-h-231.5 flex items-center bg-bg3 dark:bg-dark-bg1">
      <div className="container lg:py-0 py-20">
        {/* TITLE */}
        <p className="section-title text-center text-text13! max-lg:max-w-[374px] max-lg:mx-auto max-lg:leading-[15px]">
          Your Top Picks
        </p>

        <div className="relative w-full max-w-117.5 h-1.5 mx-auto my-5">
          <div className="absolute inset-0 bg-linear-to-r from-transparent via-primary to-transparent opacity-40" />
        </div>

        {/* HEADING */}
        <h2 className="text-text7 max-lg:text-[#262626] text-3xl lg:text-[40px] leading-10! text-center dark:text-white">
          Why Choose{" "}
          <strong className="text-primary font-black">DALAL Affiliates</strong>
        </h2>

        {/* CARDS */}
        <div className="mt-14 grid lg:grid-cols-3 gap-5 lg:gap-8">
          {whyChooseUsData?.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={index}
                className={`bg-bg7 w-full max-w-[374px] mx-auto lg:max-w-none flex flex-col rounded-2xl py-5 px-5.5 gap-3 text-white transition-all duration-500 overflow-hidden ${
                  open ? "lg:h-80" : "lg:h-52"
                }`}
              >
                {/* Icon */}
                <div className="size-9 bg-white rounded-full grid place-items-center text-text5 text-2xl shrink-0 overflow-hidden">
                  <Image
                    src={item.img}
                    width={36}
                    height={36}
                    alt={item.title}
                    className="object-contain mx-auto"
                  />
                </div>

                {/* TITLE */}
                <h3 className="font-semibold lg:text-lg">{item.title}</h3>

                {/* SHORT TEXT */}
                <p className="text-xs lg:text-sm tracking-[-0.035] lg:h-10">
                  {item.short}
                </p>

                {/* LONG TEXT */}
                <p
                  className={`text-xs lg:text-sm transition-all duration-500 ${
                    open
                      ? "opacity-100 max-h-60"
                      : "opacity-0 max-h-0 pointer-events-none"
                  }`}
                >
                  {item.long}
                </p>

                {/* BUTTON */}
                <button
                  className="flex items-center gap-3 mt-auto lg:text-base text-xs cursor-pointer"
                  onClick={() => toggle(index)}
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    viewBox="0 0 512 512"
                    className={`text-xl transition-all duration-300 ${
                      open ? "rotate-180" : ""
                    }`}
                    height="1em"
                    width="1em"
                  >
                    <path
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="48"
                      d="m112 268 144 144 144-144M256 392V100"
                    ></path>
                  </svg>

                  <span>{open ? "Read Less" : "Read More"}</span>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
